<template>
  <el-dialog width="684px" :visible="visible" :validate-on-rule-change="false" :show-close="!loading" :append-to-body="false" :close-on-click-modal="false" @update:visible="changeShow" @closed="closedDialog">
    <div v-loading="loading">
      <div class="fx top">
        <div class="w-100">
          <div ref="qrcode" class="qrcode"></div>
          <div class="qrcode-bot">登入whatsapp即可和您的客户无限畅</div>
        </div>

        <div class="fx-c w-100">
          <h4 class="fx-none title">Whatsapp登录</h4>
          <p class="fx-none">使用手机上的whatsapp扫描二维码</p>
          <div class="fx-full"></div>
          <div class="fx-none">
            <el-checkbox v-model="checked" class="mr-8"></el-checkbox> <span class="ml-8">保持登入</span>
          </div>
          <p class="fx-none">需要本机开启科学上网，才可刷新出二维码</p>
        </div>
      </div>

      <div class="footer fx">
        <div class="f-left">
          <h4 class="mb-16">如何扫码登录？</h4>
          <div class="fx">
            <div class="mr-16">
              <img src="/static/image/module/smart-gc/az.png" style="width:33px;" alt="" srcset="">
            </div>
            <div>
              <h4 class="mb-8">安卓手机</h4>
              <p> 打开Whatsapp - 相机图标 - 扫码上方二维码</p>
            </div>
          </div>
        </div>
        <div class="f-left" style="margin-left:38px;">
          <h4 class="mb-16"></h4>
          <div class="fx">
            <div class="mr-16">
              <img src="/static/image/module/smart-gc/iphone.png" style="width:31px;" alt="" srcset="">
            </div>
            <div>
              <h4 class="mb-8">苹果手机</h4>
              <p>
                打开Whatsapp-设置-已连接的设备-连接新设备-扫码上方二维码
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import popupMixin from '@/mixin/popup-mixin'
import QRCode from '@/components/QRcode'
export default {
  name: 'DialogQRCode',
  mixins: [popupMixin],
  props: ['textOfQRCode'],
  data() {
    return {
      loading: true,
      checked: true
    }
  },
  mounted() {
  },
  methods: {
    createQECode(text) {
      // 二维码
      this.$nextTick(() => {
        const qrCodeEle = this.$refs.qrcode || document.querySelector('.qrcode')
        if (qrCodeEle.hasChildNodes()) {
          qrCodeEle.replaceChildren()
        }
        new QRCode(qrCodeEle, {
          text,
          width: 180,
          height: 180,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.L
        })
        this.closeLoading()
      })
    },
    closeLoading() {
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  font-weight: 600;
}
/deep/ .el-dialog__body {
  // padding-top: 14px;
  // padding-bottom: 2px;
  padding: 0;
}
/deep/ .el-dialog__footer {
  padding-top: 0;
}
.top {
  margin-left: 50px;
}
.qrcode {
  margin-left: 45px;
  margin-bottom: 24px;
  width: 180px;
  height: 180px;
  > img {
    width: 100%;
  }
}
.qrcode-bot {
  width: 269px;
  height: 44px;
  background: #80b336;
  border-radius: 4px;
  padding: 12px;
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
}

.footer {
  margin-top: 69px;
  height: 152px;
  background: #f6f6f6;
  padding: 16px 32px 24px;

  border-radius: 0 0 12px 12px;

  .f-left {
    h4 {
      height: 22px;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
    }
  }
}
</style>
